import BaseModel from '@kakadu-dev/base-frontend-helpers/models/BaseModel';
import { Product } from "../Products";
import { Category } from "./Category";
/**
 * Category entity class
 */

export class CategoryEntity extends BaseModel {
  constructor(...args) {
    super(...args);

    this.getCategoryId = () => {
      return Number(this.model.categoryId);
    };

    this.getEntityId = () => {
      return Number(this.model.entityId);
    };

    this.getIsPrimary = () => {
      return this.model.isPrimary;
    };

    this.getType = () => {
      return this.model.type;
    };

    this.getCategory = category => {
      return this.getRelation('category', Category, category);
    };

    this.getProduct = product => {
      return this.getRelation('product', Product, product);
    };
  }

  /**
   * Create category entity
   *
   * @param {object} object
   *
   * @return {CategoryEntity}
   */
  static create(object) {
    return super.create(object);
  }
  /**
   * Create list categories entities
   *
   * @param {object} objects
   *
   * @return {Array.<CategoryEntity>}
   */


  static createList(objects) {
    return super.createList(objects);
  }
  /**
   * Map categories entities
   *
   * @param {Array.<object>} objects
   * @param {function(CategoryEntity): undefined} callback
   *
   * @return {Array.<object>}
   */


  static map(objects, callback) {
    return super.map(objects, callback);
  }
  /**
   * @inheritDoc
   */


  primaryKey() {
    return `${this.model.type},${this.model.entityId},${this.model.categoryId}`;
  }
  /**
   * Get category id
   *
   * @return {number}
   */


}